import { compose } from "recompose";
import { connect } from "react-redux";
import { withMessenger } from "src/modules/messenger/Provider";
import { logIn } from "src/modules/auth/duck/epics";
import { withApp } from "src/components/App/Context";

import Login from "./Login";

function mapDispatchToProps(dispatch, { app, messenger }) {
  return {
    logIn: (credentials) => dispatch(logIn({ ...credentials, app, messenger }))
  };
}

const enhance = compose(
  withApp,
  withMessenger,
  connect(null, mapDispatchToProps)
);

export default enhance(Login);
